import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
}), 'FormatAlignJustifyOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatAlignJustifyOutlined.js
// module id = 3800
// module chunks = 2